import Axios from 'axios'

Axios.defaults.responseType = 'json'
Axios.defaults.withCredentials = true
Axios.defaults.headers.common['Content-Type'] = 'application/json'
Axios.defaults.headers.common['Cache-Control'] =
  'no-cache,no-store,must-revalidate,max-age=-1,private'
Axios.defaults.headers.common['Pragma'] = 'no-cache'
Axios.defaults.headers.common['Expires'] = 0

export const getServerErrorMessage = (res, defaultMessage) => {
  const { message } = (res && res.response && res.response.data) || {}
  return message || defaultMessage || 'An error occurred. Please try again later.'
}

export const enterpriseRequestSettings = {
  withCredentials: false,
  transformRequest: (data, headers) => {
    headers.common = {}
    return data
  },
}

export const dispatchError = (dispatch, type, res, customMessage) =>
  dispatch({ type, payload: getServerErrorMessage(res, customMessage) })

export default Axios
